// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tWNxL","label":"styles_label__GfQSq"};